module.exports = __webpack_public_path__ + "static/media/06-benefit-newsletter.2469e4b1.jpg";